/* eslint-disable camelcase */
import { DataLayerEvent, PushDataLayerFn } from "frontend/hooks/use-data-layer";
import { KalturaPlayerInstance } from "./kaltura-embed";

export function setKalturaV7VideoEvents(
  player: KalturaPlayerInstance,
  pushDataLayer: PushDataLayerFn,
) {
  const videoType = "recorded";
  const videoTitle = player.title || "Unknown Title";
  const videoTargetId = player.videoTargetId || "";

  // Track milestones
  const milestones = [0.01, 0.25, 0.5, 0.75, 1];
  const milestonesReached: Set<number> = new Set();

  //Set focus to player container when video starts playing
  player.addEventListener(player.Event.PLAY, () => {
    setTimeout(() => {
      const playerDiv = document.querySelector(
        `#${videoTargetId} .playkit-player`,
      );
      if (playerDiv) {
        (playerDiv as HTMLElement).focus();
      }
    }, 500);
  });

  player.addEventListener(player.Event.TIME_UPDATE, () => {
    const { currentTime, duration } = player;
    if (!duration) return;

    const progress = currentTime / duration;

    milestones.forEach((milestone) => {
      if (progress >= milestone && !milestonesReached.has(milestone)) {
        milestonesReached.add(milestone);

        const event: DataLayerEvent = {
          event: "video",
          event_data: {
            video_title: videoTitle,
            video_type: videoType,
            video_duration: duration,
            video_milestone: milestone * 100,
          },
        };

        pushDataLayer(event);
      }
    });
  });
}
